@use 'kci-design-lib/styles/variables.scss' as *;
.navContainer {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 447px;
  overflow-y: auto;
  height: calc(100% - 19px);
  background: var(--navlink-item-bg, transparent);
  .activeSelectedBg {
    img {
      filter: var(--navlink-icon-hover-filter, var(--filter-icon-accent)) !important;
    }
    .icon {
      &.outline {
        &.baseicon,
        &.socialmediaicon {
          filter: var(--navlink-icon-hover-filter, var(--filter-icon-accent)) !important;
        }
      }
    }
    .label,
    .description,
    .navheading,
    span {
      color: var(--navlink-hover-text, #{$pbl-bkgd-hover}) !important;
    }
    .count {
      color: var(--navlink-count-text, #{$sbd-text-hover}) !important;
    }
  }
  [data-pc-section='container'] {
    overflow: inherit;
    button:hover {
      border: 0px solid transparent;
    }
  }
  [data-pc-name='tree'] {
    border: 0;
    padding: 0;
    font-family: $font-family;
    li {
      padding: 0px;
      margin: 0px;
      width: 100%;
      [data-pc-section='content'] {
        padding: 0px;
        border-radius: 0px;
        border-bottom: 1px solid var(--navlink-item-border, #{$border-dark});
        &[data-p-highlight='true'] {
          background: var(--navlink-hover-bg, #{$border-dark});
          box-shadow: none;
        }
        .p-treenode-selectable {
          background: var(--navlink-hover-bg, #{$border-dark});
        }
      }
      [data-pc-section='subgroup'] {
        .navLink {
          border: 0px;
        }
        padding-left: 0px;
        .navheading {
          flex: 1;
        }
      }
    }
    .navLink {
      width: 447px;
      padding: 18px 16px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      background: transparent;
      transition: all 0.2s ease-in-out;
      button {
        padding: 0px;
        width: 24px;
        height: 24px;
        img {
          filter: var(--filter-icon-neutral);
        }
      }
      .icon {
        margin: 0px 16px 0 0;
      }
      .label {
        font-size: 18px;
        font-weight: 350;
        line-height: 24px;
        letter-spacing: 0px;
        font-family: $font-family;
        width: 100%;
        display: inline-block;
      }
      .count {
        background: var(--navlink-count-bg, #{$pbl-bkgd});
        border-radius: 40px;
        padding: 6px 12px;
        font-size: 14px;
        color: var(--navlink-count-text, #{$sbd-text-hover});
        font-weight: 400;
        letter-spacing: 0.75px;
        line-height: 20px;
        margin: 0;
        width: 33px;
        height: 24px;
        display: inline-flex;
        align-items: center;
      }
      &[data-pc-section='content'] {
        border-radius: 0px;
      }
      .label,
      .navheading {
        color: var(--navlink-text-color, inherit);
      }
      [data-pc-section='content'] {
        span {
          color: var(--navlink-text-color, inherit);
        }
      }
    }
    [data-pc-section='container'] {
      [data-pc-section='node'] {
        &:focus {
          [data-pc-section='content'] {
            box-shadow: unset;
          }
        }
      }
    }
    [data-pc-section='subgroup'] {
      .navLink {
        .label {
          font-size: 12px;
          font-weight: 600;
          line-height: 18px;
          letter-spacing: 0.2px;
        }
        span {
          font-size: 16px;
          font-weight: 600;
          line-height: 24px;
          letter-spacing: 0.2px;
        }
        &.activepressed {
          img {
            filter: unset;
          }
        }
        &.hover {
          img {
            filter: unset;
          }
        }
      }
    }
    [data-pc-section='content'] {
      color: var(--text-subtle-strong);
      border-radius: 0px; 
      img {
        filter: var(--filter-icon-neutral);
      }
      &:hover,
      &:has(.hover),
      &:has(.activepressed),
      &[data-p-highlight='true'] {
        background-color: var(
          --navlink-hover-bg,
          #{$border-dark}
        ); 
        border-bottom: 1px solid var(--border-elevated);
        color: var(
          --navlink-hover-text,
          #{$pbl-bkgd-hover}
        ); 
        img {
          filter: var(--navlink-icon-hover-filter, var(--filter-icon-accent));
        }
      }
      &:has(.activepressed),
      &[data-p-highlight='true'] {
        .label {
          color: var(--navlink-hover-text, #{$pbl-bkgd-hover});
          &:not(:has(+ span)) {
            font-weight: 700;
          }
        }
      }
      &:has(.disabled) {
        background: var(
          --navlink-disabled-bg,
          #{$sbd-text}
        ); 
        border-bottom: 1px solid transparent;
        pointer-events: none;
        color: var(
          --navlink-disabled-text,
          #{$pbl-text-dsbl}
        ); 
        border-radius: 0px;
        [role='button'] {
          button {
            pointer-events: none;
            img {
              filter: var(
                --navlink-disabled-icon,
                brightness(0) saturate(100%) invert(83%) sepia(5%) saturate(0%) hue-rotate(191deg)
                  brightness(87%) contrast(87%)
              );
            }
          }
        }
        img {
          filter: var(
            --navlink-disabled-icon,
            brightness(0) saturate(100%) invert(83%) sepia(5%) saturate(0%) hue-rotate(191deg)
              brightness(87%) contrast(87%)
          );
        }
        .count {
          background-color: var(--navlink-disabled-bg, #{$pbl-text-dsbl});
        }
      }
      .navLinkStatus {
        img {
          filter: unset;
        }
      }
    }
    .iconFilled {
      &[data-button-type='tertiary'] {
        img {
          filter: var(--filter-icon-accent);
        }
      }
    }
  }
  .p-tree {
    .p-treenode-children {
      padding: 0px;
    }
  }
  .prefix {
    &:not(:empty) {
      margin-right: 12px;
    }
    .side-slot {
      display: none;
    }
  }
  .buttonWrapper {
    display: flex;
    align-items: center;
    cursor: pointer;
    [alt='Chevron Down'] {
      rotate: -90deg;
    }
    [alt='Chevron Up'] {
      rotate: -180deg;
    }
  }
  .rightContent {
    display: flex;
    margin-right: auto;
    align-items: center;
    gap: 12px;
  }
  &[data-dragdrop-enabled='true'] {
    [data-pc-section='droppoint'] {
      display: block;
      min-height: 8px;
    }
  }
  [data-pc-name='tree'],
  [data-pc-section='container'] {
    background: var(--navlink-item-bg, transparent);
  }
  img,
  .icon.baseicon.outline,
  .icon.socialmediaicon.outline {
    filter: var(--navlink-icon-filter, none);
  }
  .navLinkStatus img,
  .navLinkStatus .status-svg-icon {
    filter: none;
  }
}
.label {
  flex: 1;
}
.icon {
  margin-left: 8px;
}
.navheading {
  flex: 1;
  margin-left: 0;
}
[data-pc-name='tree'] button.button--tertiary:hover {
  border: 0px solid transparent;
}
.icon-container {
  margin-right: 0px;
}
[data-pc-name='sidebar'] {
  [data-pc-section='subgroup'] {
    [data-pc-section='content'] {
      .activeSelectedBg {
        img[alt='Folder'],
        img[alt='Chevron Up'] {
          filter: brightness(0) saturate(100%) invert(16%) sepia(72%) saturate(2478%)
            hue-rotate(209deg) brightness(91%) contrast(109%);
        }
      }
    }
  }
}
html[data-theme='dark'] {
  .navContainer {
    .activeSelectedBg {
      .label,
      .description,
      .navheading,
      span {
        color: var(--navlink-hover-text, #def7ff) !important;
      }
    }
    .prefix img,
    .icon.baseicon.outline,
    .icon.socialmediaicon.outline {
      filter: brightness(0) saturate(100%) invert(100%) sepia(58%) saturate(1827%) hue-rotate(173deg) brightness(103%) contrast(101%) !important;
    }
    [data-pc-name='tree'] {
      [data-pc-section='content'] {
        img {
          filter: var(--navlink-icon-filter) !important;
        }
        .prefix img,
        .prefix .icon.baseicon.outline,
        .prefix .icon.socialmediaicon.outline {
          filter: brightness(0) saturate(100%) invert(100%) sepia(58%) saturate(1827%) hue-rotate(173deg) brightness(103%) contrast(101%) !important;
        }
        .navLinkStatus img,
        .navLinkStatus .status-svg-icon {
          filter: none !important;
        }
        &:hover,
        &:has(.hover),
        &:has(.activepressed),
        &[data-p-highlight='true'] {
          .label,
          .description,
          .navheading,
          span {
            color: var(--navlink-hover-text, #def7ff) !important;
          }
          img {
            filter: var(--navlink-icon-hover-filter) !important;
          }
          .navLinkStatus img,
          .navLinkStatus .status-svg-icon {
            filter: none !important;
          }
        }
      }
    }
  }
}
